<template>
  <a :href="'mailto:' + supportEmail">
    <slot>
      {{ supportEmail }}
    </slot>
  </a>
</template>

<script setup lang="ts">
const { supportEmail } = useCommunication();
</script>